import React from "react";

const Analytics = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1142_17605"
        style={{ maskType: "alpha" }}   // ✅ FIXED
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>

      <g mask="url(#mask0_1142_17605)">
        <path
          d="M3.65 19.7C3.55083 19.7 3.46767 19.6663 3.4005 19.599C3.3335 19.5318 3.3 19.4485 3.3 19.349C3.3 19.2497 3.3335 19.1667 3.4005 19.1C3.46767 19.0333 3.55083 19 3.65 19H20.35C20.4492 19 20.5322 19.0337 20.5992 19.101C20.6664 19.1682 20.7 19.2515 20.7 19.351C20.7 19.4503 20.6664 19.5333 20.5992 19.6C20.5322 19.6667 20.4492 19.7 20.35 19.7H3.65ZM5.153 17C4.91767 17 4.71667 16.9173 4.55 16.752C4.38333 16.5868 4.3 16.3862 4.3 16.15V13.15C4.3 12.9138 4.38233 12.7132 4.547 12.548C4.71167 12.3827 4.91167 12.3 5.147 12.3C5.38233 12.3 5.58333 12.3827 5.75 12.548C5.91667 12.7132 6 12.9138 6 13.15V16.15C6 16.3862 5.91767 16.5868 5.753 16.752C5.58833 16.9173 5.38833 17 5.153 17ZM9.703 17C9.46767 17 9.26667 16.9173 9.1 16.752C8.93333 16.5868 8.85 16.3862 8.85 16.15V8.14999C8.85 7.91382 8.93233 7.71315 9.097 7.54799C9.26167 7.38265 9.46167 7.29999 9.697 7.29999C9.93233 7.29999 10.1333 7.38265 10.3 7.54799C10.4667 7.71315 10.55 7.91382 10.55 8.14999V16.15C10.55 16.3862 10.4677 16.5868 10.303 16.752C10.1383 16.9173 9.93833 17 9.703 17ZM14.278 17C14.0427 17 13.8417 16.9173 13.675 16.752C13.5083 16.5868 13.425 16.3862 13.425 16.15V11.15C13.425 10.9138 13.5073 10.7132 13.672 10.548C13.8367 10.3827 14.0367 10.3 14.272 10.3C14.5073 10.3 14.7083 10.3827 14.875 10.548C15.0417 10.7132 15.125 10.9138 15.125 11.15V16.15C15.125 16.3862 15.0427 16.5868 14.878 16.752C14.7133 16.9173 14.5133 17 14.278 17ZM18.853 17C18.6177 17 18.4167 16.9173 18.25 16.752C18.0833 16.5868 18 16.3862 18 16.15V5.14999C18 4.91382 18.0823 4.71315 18.247 4.54799C18.4117 4.38265 18.6117 4.29999 18.847 4.29999C19.0823 4.29999 19.2833 4.38265 19.45 4.54799C19.6167 4.71315 19.7 4.91382 19.7 5.14999V16.15C19.7 16.3862 19.6177 16.5868 19.453 16.752C19.2883 16.9173 19.0883 17 18.853 17Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default Analytics;